import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import InputMask from 'react-input-mask';
import $ from 'jquery';
import LocalizedStrings from 'react-localization';
import img1 from '../img/apply-thank.svg';
import img2 from '../img/apply-thank-img.png';
import img2Webp from '../img/apply-thank-img.webp';
import img3 from '../img/apply-thank-img-mob.png';
import img3Webp from '../img/apply-thank-img-mob.webp';
import img4 from '../img/apply-sorry.svg';
import { KaskoService } from '../services/kaskoService';
import spinnerIcon from '../img/spinner.svg';
import Conditions from './Conditions';


class ApplyForm extends Component {
  state = {
    loading: false,
    step: 1,
    number: '',
    name: '',
    mail: '',
    code: '',
    dataShow: false,
    hasError: false,
    reSendOtpLoading: false,
    orderSuccess: null,
    correctOtp: null,
    formErrors: {
      name: true,
      mail: true,
      number: true
    }
  };

  componentDidMount() {
    $(() => {
      $('.apply-info .btn-more').click(function () {
        $(this).toggleClass('btn-hide');
        $('.p-hide').toggleClass('p-show');
      });
    });
  }

  handleInput = (e) => {
    const { id, value } = e.target;
    let formErrors = this.state.formErrors;
    let regExp = '';

    switch (id) {
      case "name":
        regExp = /^([Ѐ-Ӿ]+-?\'?)+([Ѐ-Ӿ]+\s?\-?\'?)*$/;
        formErrors.name = !regExp.test(value);
        break;
      case "mail":
        regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        formErrors.mail = !regExp.test(value);
        break;
      case "number":
        formErrors.number = value.length < 19;
        break;
      default: break;
    }

    if (id === 'number') {
      this.setState({ ...this.state, formErrors, [id]: this.changeNumber(value) })
    } else {
      this.setState({ ...this.state, formErrors, [id]: value })
    }
  };

  nextStep = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState(({ step }) => {
        return { step: step + 1, loading: false, hasError: false }
      });
    }, 1000);
  };

  prevStep = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState(({ step }) => {
        return { step: step - 1, loading: false, hasError: false }
      });
    }, 1000);
  };

  // отправка otp
  onSendOtp = (e) => {
    // window.gtag('event', 'click', { 'event_category': 'button4' });
    e.preventDefault();
    const { number, formErrors } = this.state;
    const { sendOtp } = new KaskoService();

    if (formErrors.name === false && formErrors.mail === false && formErrors.number === false) {
      this.setState({ loading: true });

      sendOtp(number)
        .then(() => {
          this.setState({
            loading: false,
            hasError: false,
          });
          this.nextStep();
        })
        .catch(() => {
          this.setState({
            loading: false,
            hasError: true
          });
        });
    } else {
      this.setState({ loading: true });
      setTimeout(() => {
        this.setState({ loading: false, hasError: true });
      }, 1000);
    }
  };

  changeNumber = (value) => {
    return `+${value.replace(/[^\d]/g, '')}`;
  };

  // повторная отправка otp
  onReSendOtp = (e) => {
    e.preventDefault();
    const { number } = this.state;
    const { reSendOtp } = new KaskoService();

    this.setState({
      reSendOtpLoading: true
    });

    setTimeout(() => {
      reSendOtp(number)
        .then((res) => {
          this.setState({
            reSendOtpLoading: false,
            hasError: false
          });
        })
        .catch((e) => {
          this.setState({
            reSendOtpLoading: false,
            hasError: true
          });
        });
    }, 2000);
  };

  // создать ордер
  onCreateOrder = (e) => {
    e.preventDefault();
    const { createOrder } = new KaskoService();
    const { markId: carMark, modelId: carModel, years: carYear, mileage: carMileage, carNumber, isTaxi, isCredit, carPrice } = JSON.parse(localStorage.getItem('carOptions'));
    const { name: insuranceCompany, tarif: { name: program, amount, amountWithDiscount } } = JSON.parse(localStorage.getItem('tarif'));
    const payment = amountWithDiscount ? amountWithDiscount : amount;
    const { name: fio, number: phone, code: otp } = this.state;

    const options = {
      fio,
      phone,
      carMark,
      carModel,
      carYear,
      carMileage,
      carNumber: carNumber ? carNumber : 'false',
      carPrice,
      isTaxi,
      isCredit,
      program,
      insuranceCompany,
      payment,
      otp
    };

    this.setState({
      loading: true,
    });

    createOrder(options)
      .then((res) => {
        const { result } = res.data;

        if (result) {
          this.setState({
            loading: false,
            orderSuccess: true,
            correctOtp: true
          });
          this.nextStep();
          this.props.addToDataLayer('/thank-you');
        } else {
          this.setState({
            loading: false,
            orderSuccess: true,
            correctOtp: false
          });
          this.nextStep();

        }
      })
      .catch((err) => {
        console.log('error ==>>>', err);
        this.setState({
          loading: false,
          orderSuccess: false,
          correctOtp: false
        });
        this.nextStep()
      });
  };

  showData = () => {
    this.setState(({ dataShow }) => {
      return {
        dataShow: !dataShow
      }
    });

    window.scrollTo(0, 0);
  };

  render() {
    const { formErrors } = this.state;
    const strings = new LocalizedStrings({
      ru: {
        name: 'Фамилия, имя, отчество',
        namePlaceholder: 'Иванов Иван Иванович',
        phone: 'Телефон',
        phone2: 'Укажите ваш телефон',
        txt1: 'Нажимая на кнопку, вы соглашаетесь с',
        txt2: 'условиями обработки персональных данных',
        offer: 'подать заявку',
        txt3: 'Назовете промокод при звонке и получите',
        txt4: 'скидку',
        please: 'Пожалуйста, подтвердите номер телефона, чтобы продолжить.',
        code1: 'Код подтверждения был отправлен на номер',
        code2: 'Код подтверждения',
        thanks: 'Спасибо за доверие!',
        txt5: 'Ваша заявка успешно принята.',
        txt6: 'Ожидайте ответа в ближайшее время!',
        txt7: 'Заявки обрабатываются в рабочее время Пн-Пт с 9:00 до 18:00. С Вами обязательно свяжется наш специалист в кратчайшие сроки!',
        cabinet: 'В личный кабинет',
        main: 'На главную',
        auto: 'Автогражданка',
        from: 'от',
        noOtp: 'Не пришло сообщение?',
        reSendOtp: 'Нажмите сюда',
        applySorryTitle: 'К сожалению, произошла ошибка!',
        applySorryText: 'Попробуйте, пожалуйста, еще раз.',
        incorrectOtpTitle: 'К сожалению, произошла ошибка!',
        incorrectOtpText: 'Вы указали неверный Код подтверждения.',
        incorrectOtpBtn: 'Вернуться',
        errName: 'Допускается только кириллица',
        errMail: 'Введите адрес эл. почты',
      },
      ua: {
        name: "Прізвище ім'я по-батькові",
        namePlaceholder: 'Іванов Іван Іванович',
        phone: 'Телефон',
        phone2: 'Вкажіть ваш телефон',
        txt1: 'Натискаючи на кнопку, ви погоджуєтеся з',
        txt2: 'умовами обробки персональних даних',
        offer: 'Подати заявку',
        txt3: 'Назвете промокод при дзвінку та отримаєте',
        txt4: 'знижку',
        please: 'Будь-ласка, підтвердіть номер телефону, щоб продовжити.',
        code1: 'Код підтвердження був надісланий на номер',
        code2: 'Код підтвердження',
        thanks: 'Дякуємо за довіру!',
        txt5: 'Ваша заявка успішно прийнята.',
        txt6: 'Очікуйте відповіді у найближчий час!',
        txt7: 'Заявки обробляються у робочий час Пн-Пт з 9:00 до 18:00. З Вами обов\'язково зв\'яжеться наш спеціаліст у найкоротший термін!',
        cabinet: 'До особистого кабінету',
        main: 'На головну',
        auto: 'Автоцивілка',
        from: 'від',
        noOtp: 'Не прийшло повідомлення?',
        reSendOtp: 'Натисніть сюди',
        applySorryTitle: 'На жаль, виникла помилка!',
        applySorryText: 'Спробуйте, будь ласка, ще раз.',
        incorrectOtpTitle: 'На жаль, виникла помилка!',
        incorrectOtpText: 'Ви вказали невірний Код підтвердження.',
        incorrectOtpBtn: 'Повернутися',
        errName: "Допускається лише кирилиця",
        errMail: 'Вкажіть адрес ел. пошти',
      },
    });

    strings.setLanguage(this.props.locale);

    return (
      <div className={`apply-form apply_step-${this.state.step - 1}`}>

        {/* form-1 */}
        {this.state.step === 1
          && (
            <form onSubmit={this.onSendOtp} className={this.state.loading ? "val-form pointer-events-none" : "val-form"} >
              <div className="top">
                {/* name */}
                <div className="form-group">
                  <label>{strings.name}*</label>
                  <div className={formErrors.name && this.state.hasError ? 'form-tel validation-error' : 'form-tel'}>
                    <input
                      onChange={this.handleInput}
                      value={this.state.name}
                      id="name"
                      type="text"
                      className="form-control"
                      placeholder={strings.namePlaceholder}
                    />
                    {formErrors.name && (<div className="error">{strings.errName}</div>)}
                  </div>
                </div>
                {/* End name */}

                {/* email */}
                <div className="form-group">
                  <label>E-mail*</label>
                  <div className={formErrors.mail && this.state.hasError ? 'form-tel validation-error' : 'form-tel'}>
                    <input
                      onChange={this.handleInput}
                      value={this.state.mail}
                      id="mail"
                      className="form-control"
                      placeholder="E-mail"
                    />
                    {formErrors.mail && (<div className="error">{strings.errMail}</div>)}
                  </div>
                </div>
                {/* end email */}

                {/* phone */}
                <div className="form-group">
                  <label>{strings.phone}*</label>
                  <div className={formErrors.number && this.state.hasError ? 'form-tel validation-error' : 'form-tel'}>
                    <InputMask
                      onChange={this.handleInput}
                      mask="+38 (999) 999-99-99"
                      // mask="+389999999999"
                      className="form-control"
                      // placeholder="+38"
                      placeholder="+38 (___) - ___ - __- __"
                      maskChar=""
                      id="number"
                      value={this.state.number}
                      type="tel"
                    />
                    {formErrors.number && <div className="error">{strings.phone2}</div>}
                  </div>
                </div>
                {/* End phone */}

                <div className="txt-conditions">
                  <p>{strings.txt1} <a href="#" onClick={this.showData}>{strings.txt2}</a></p>
                </div>

                {this.state.dataShow && <Conditions changeData={this.showData} locale={this.props.locale} />}

                <div className="flex flex_j-center">
                  {this.state.loading ?
                    <div className="btn-valid"><img src={spinnerIcon} alt="loading" /></div>
                    : <div className={this.state.loading ? 'btn-valid btn-disabled' : 'btn-valid'}>
                      <button disabled={this.state.loading} type="submit" className="btn btn-bg">{strings.offer}</button>
                    </div>}
                </div>
              </div>

              {/*<div className="form-bottom">*/}
              {/*  <div className="line">*/}
              {/*    <svg width={464} height={4} fill="none">*/}
              {/*      <path d="M0 2H464" stroke="url(#sline)" strokeWidth={4} />*/}
              {/*      <defs>*/}
              {/*        <linearGradient id="sline" x1="-4.99999" y1="1.99998" x2={464} y2="2.00142" gradientUnits="userSpaceOnUse">*/}
              {/*          <stop stopColor="#FFD83A">*/}
              {/*            <animate attributeName="stop-color" values="#FFD83A; #1487CF; #FFD83A;" dur="2s" repeatCount="indefinite" />*/}
              {/*          </stop>*/}
              {/*          <stop offset="0.74" stopColor="#1487CF">*/}
              {/*            <animate attributeName="stop-color" values="#1487CF; #FFD83A; #1487CF;" dur="2s" repeatCount="indefinite" />*/}
              {/*          </stop>*/}
              {/*          <stop offset={1} stopColor="#1487CF">*/}
              {/*            <animate attributeName="stop-color" values="#1487CF;#FFD83A;#1487CF;" dur="2s" repeatCount="indefinite" />*/}
              {/*          </stop>*/}
              {/*        </linearGradient>*/}
              {/*      </defs>*/}
              {/*    </svg>*/}
              {/*  </div>*/}
              {/*  <div className="text-center">*/}
              {/*    <p>{strings.txt3} <span className="bold">{strings.txt4} 10%</span></p>*/}
              {/*  </div>*/}
              {/*  <div className="form-action row">*/}
              {/*    <div className="value">-10%</div>*/}
              {/*    <div className="flex">*/}
              {/*      <div className="tit">Промокод</div>*/}
              {/*      <div className="code">POLIS10</div>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</div>*/}
            </form>
          )}
        {/* End form-1 */}

        {/* form-2 */}
        {this.state.step === 2
          && (
            <form onSubmit={this.onCreateOrder} className={this.state.loading ? "val-form pointer-events-none" : "val-form"} autoComplete="off">
              <div className="top">
                <div className="txt">
                  <p className="mt-0">{strings.please}</p>
                  <p className="mt-30">{strings.code1} <span className="bold">{this.state.number}</span></p>
                </div>
                <div className="form-group">
                  <label>{strings.code2}</label>
                  <input id="code" onChange={this.handleInput} type="text" className="form-control" placeholder="AB458" />
                </div>

                <div className="flex flex_j-center">
                  {this.state.loading ?
                    <img src={spinnerIcon} alt="loading" />
                    :
                    <div
                      className={this.state.loading || this.state.code.length < 1 || this.state.reSendOtpLoading ? 'btn-valid btn-disabled' : 'btn-valid'}>
                      <button type="submit"
                        className="btn btn-bg"
                        disabled={this.state.loading || this.state.code.length < 1 || this.state.reSendOtpLoading}
                      >
                        {strings.offer}
                      </button>
                    </div>
                  }
                </div>

                {/* resend otp */}
                <div className="resend-otp">
                  <span>{strings.noOtp}</span>
                  {
                    this.state.reSendOtpLoading ?
                      <img src={spinnerIcon} alt="loading" /> :
                      <span className="resend-otp-btn" onClick={this.onReSendOtp}>{strings.reSendOtp}</span>
                  }
                </div>
                {/* End resend otp */}

              </div>
              {/*<div className="form-bottom">*/}
              {/*  <div className="line">*/}
              {/*    <svg width={464} height={4} fill="none">*/}
              {/*      <path d="M0 2H464" stroke="url(#sline)" strokeWidth={4} />*/}
              {/*      <defs>*/}
              {/*        <linearGradient id="sline" x1="-4.99999" y1="1.99998" x2={464} y2="2.00142" gradientUnits="userSpaceOnUse">*/}
              {/*          <stop stopColor="#FFD83A">*/}
              {/*            <animate attributeName="stop-color" values="#FFD83A; #1487CF; #FFD83A;" dur="2s" repeatCount="indefinite" />*/}
              {/*          </stop>*/}
              {/*          <stop offset="0.74" stopColor="#1487CF">*/}
              {/*            <animate attributeName="stop-color" values="#1487CF; #FFD83A; #1487CF;" dur="2s" repeatCount="indefinite" />*/}
              {/*          </stop>*/}
              {/*          <stop offset={1} stopColor="#1487CF">*/}
              {/*            <animate attributeName="stop-color" values="#1487CF;#FFD83A;#1487CF;" dur="2s" repeatCount="indefinite" />*/}
              {/*          </stop>*/}
              {/*        </linearGradient>*/}
              {/*      </defs>*/}
              {/*    </svg>*/}
              {/*  </div>*/}
              {/*  <div className="form-action row">*/}
              {/*    <div className="value">-10%</div>*/}
              {/*    <div className="flex">*/}
              {/*      <div className="tit">Промокод</div>*/}
              {/*      <div className="code">POLIS10</div>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*  <div className="text-center">*/}
              {/*    <p>{strings.txt3}<br /> {strings.txt4} 10%</p>*/}
              {/*  </div>*/}
              {/*</div>*/}
            </form>
          )}
        {/* End form-2 */}

        {/* form-3 */}
        {this.state.step === 3
          && (
            <form className="val-form">
              {
                (this.state.orderSuccess && this.state.correctOtp) && (
                  <div className="top">
                    <div className="img text-center">
                      <img src={img1} alt="success" />
                    </div>
                    <div className="txt text-center">
                      <p className="tit">{strings.thanks}</p>
                      <p>{strings.txt5}</p>
                      <p>{strings.txt6}</p>
                      <p>{strings.txt7}</p>
                    </div>
                    <div className="flex flex_j-center">
                      <Link to={this.props.locale === 'ua' ? '/uk/kasko' : '/kasko'} className="btn btn-bg">{strings.main}</Link>
                    </div>
                  </div>
                )
              }

              {
                (this.state.orderSuccess && !this.state.correctOtp) && (
                  <div className="top">
                    <div className="img text-center">
                      <img src={img4} alt="incorrect opt code" className="apply-sorry" />
                    </div>
                    <div className="txt text-center">
                      <p className="tit">{strings.incorrectOtpTitle}</p>
                      <p>{strings.incorrectOtpText}</p>
                    </div>
                    <div className="flex flex_j-center">
                      <button type="button" onClick={this.prevStep} className="btn btn-bg" >{strings.incorrectOtpBtn}</button>
                    </div>
                  </div>
                )
              }

              {
                (!this.state.orderSuccess && !this.state.correctOtp) && (
                  <div className="top">
                    <div className="img text-center">
                      <img src={img4} alt="error" className="apply-sorry" /></div>
                    <div className="txt text-center">
                      <p className="tit">{strings.applySorryTitle}</p>
                      <p>{strings.applySorryText}</p>
                    </div>
                    <div className="flex flex_j-center">
                      <Link to={this.props.locale === 'ua' ? '/uk/kasko' : '/kasko'} className="btn btn-bg">{strings.main}</Link>
                    </div>
                  </div>
                )
              }

              {/* banner */}
              <a href={this.props.locale === "ua" ? "https://polis.ua/uk/osago": "https://polis.ua/osago"}>
                <div className="form-bottom auto-banner3">
                  <div className="flex flex_j-space-between">
                    <div className="txt">
                      <h3>{strings.auto} <br />онлайн </h3>
                      <div className="price">{strings.from} 450 грн</div>
                    </div>
                  </div>
                  <div className="img">
                    <picture>
                      <source srcSet={img2Webp} type="image/webp" />
                      <img src={img2} alt="car" />
                    </picture>
                    <picture>
                      <source srcSet={img3Webp} type="image/webp" />
                      <img src={img3} alt="car" className="img-mob" />
                    </picture>
                  </div>
                  <div className="bg">
                    <img src="img/apply-thank-mob-bg.svg" alt="" className="img-mob" />
                    <svg width={414} height={162} viewBox="0 0 414 162" fill="none" className="bg1"><path opacity="0.4" d="M337 0C350.202 0 398.51 0 411.024 0C412.68 0 414 1.34315 414 3V159C414 160.657 412.657 162 411 162H0C7.88571 140.81 24.7147 123.038 49.849 119.279C74.9832 115.519 135.131 132.949 154 119.279C207.705 80.3691 253.644 0 337 0Z" fill="url(#aplbg1)" /><defs><linearGradient id="aplbg1" x1="170.669" y1={162} x2="382.252" y2="38.8365" gradientUnits="userSpaceOnUse"><stop stopColor="#1487CF" /><stop offset="0.293" stopColor="#1487CF" /><stop offset={1} stopColor="#FFD83A" /></linearGradient></defs></svg>
                    <svg width={383} height={162} viewBox="0 0 383 162" fill="none" className="bg2"><path d="M383 0V159C383 160.657 381.657 162 380 162H0C25.8829 121.843 82.7028 159.981 117.147 141.347C169.639 112.95 148 96 195 80.5C242 65 273.199 24.5456 314 13C340.599 5.47334 383 0 383 0Z" fill="url(#aplbg2)" /><defs><linearGradient id="aplbg2" x1="184.961" y1="161.999" x2="400.32" y2="33.0935" gradientUnits="userSpaceOnUse"><stop stopColor="#1487CF" /><stop offset="0.293" stopColor="#1487CF" /><stop offset={1} stopColor="#FFD83A" /></linearGradient></defs></svg>
                  </div>
                </div>
              </a>
              {/* End banner */}

            </form>
          )}
        {/* End form-3 */}
      </div>
    );
  }
}

export default ApplyForm;
